import { render, staticRenderFns } from "./HuongDanVienList.vue?vue&type=template&id=66630b2f&"
import script from "./HuongDanVienList.vue?vue&type=script&lang=js&"
export * from "./HuongDanVienList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports